// extracted by mini-css-extract-plugin
export default {"wrapper_cookie":"cookie_wrapper_cookie__YCElp","privacy":"cookie_privacy__HWehz","link":"cookie_link__VZIQj","button":"cookie_button__ZfSTq"};